export class OuvrageDto {
    id!: number;
    dateMiseService!: Date;
    description!: string;
    nom!: string;
    cacId!: number;
    //modeleOuvrageId!: number;
    ouvrageElectriqueParentId!: number;
    idParc!: number;
    idSousParc!: number | null;
    numeroSerie!: string;
    //etat!: boolean;
    idDarwin!: string;
    idCarl!: string;
    idClasse!: number;
    codeClasse!: string;
}